export const PAGE_NAVIGATION_EVENT = 'Page Navigation';
